import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/components.css';
import App from './App';

// Backup only: CRA's react-error-overlay registers before this file runs, so the primary
// filter lives in public/index.html (inline script before the bundle). Keep this for safety.
if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    'error',
    (e) => {
      if (typeof e.message === 'string' && e.message.includes('ResizeObserver loop')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
